import * as React from 'react';
import * as vars from '../consts/variables';
import { replacePlaceholders, __ } from '../helpers/TranslationService';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        width: '100%',
        position: 'relative',
        color: vars.acqa,
    },

    fromPrice: {
        marginRight: 2,
        fontWeight: 'normal',
    },
    perPerson: {
        marginLeft: 2,
        fontWeight: 'normal',
    },
    discountWrapper: {
        fontSize: 12,

        color: vars.pink,
        fontWeight: 'bold',
        lineHeight: 1.83,
    },
    priceInfo: {
        fontSize: 12,
        flex: '1 1 auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        marginRight: -5,
    },
};

interface IProps {
    price: number; // Ugly but we need this in order to handle additional strings properly
    priceString: string;
    allInPriceString?: string;
    discount: number;
    isHeader?: boolean;
    wrapperStyle?: any;
    discountThreshold?: number;
    includesFlight?: boolean;
    isPriceFrom?: boolean;
    onRequest?: boolean;
}

export function PerPersonPriceSmall({
    price,
    priceString,
    allInPriceString,
    discount,
    discountThreshold,
    isHeader = false,
    isPriceFrom,
    wrapperStyle,
    includesFlight,
    onRequest,
}: IProps) {
    const hasDiscount = discountThreshold ? discount >= discountThreshold : discount > 0;
    const mergedWrapperStyle: any = wrapperStyle
        ? { ...styles.wrapper, ...wrapperStyle }
        : styles.wrapper;

    const isPrice = price > 0;
    const priceStyle: React.CSSProperties = {
        fontWeight: 'normal',
        fontSize: '12px',
    };

    if (!price || onRequest) {
        return (
            <div style={styles.priceInfo}>
                <span style={priceStyle}>{priceString || __('on request', 'dreamlines')} </span>
            </div>
        );
    }

    return (
        <div style={mergedWrapperStyle}>
            {hasDiscount && (
                <div style={styles.discountWrapper}>
                    {replacePlaceholders(__('upToXDiscount', 'dreamlines'), [`-${discount}%`])}
                </div>
            )}
            <div style={styles.priceInfo}>
                {isPrice && (isHeader || isPriceFrom) && (
                    <span style={styles.fromPrice}>{__('from', 'dreamlines')}</span>
                )}
                <div>
                    <span style={priceStyle}>{priceString}</span>
                    {!Number.isNaN(Number.parseInt(priceString, 10)) && (
                        <span style={styles.perPerson}>{__('p.P.', 'dreamlines')}</span>
                    )}
                    {includesFlight && ` ${__('including flight', 'dreamlines')}`}
                </div>
            </div>
            {!!allInPriceString && <div style={priceStyle}>{allInPriceString}</div>}
        </div>
    );
}
